export * from './lib/menu-rio-ui.module';
